export interface WMSOrderFiltersType {
    currentWarehouseId: string;
    sortingCode: string;
    trackingNumbers?: string;
    platformId?: number;
    channelId?: string[];
    channelIds?: number[];
    channelOrderNumber?: string;
    externalTrackingNumber?: string;
    orderTime?: [string | null, string | null] | null;
    sortingCodeSegment1?: string;
    sortingCodeSegment2?: string;
    sortingCodeSegment3?: string;
    hubId?: string; // Hub ID（用于通过 parent_site_id 关联查询）
    warehouseId?: string; // Warehouse ID（用于直接查询该 warehouse 的订单）
    receiverZipcode?: string[]; // 邮编列表（查询时使用）
    receiverZipcodeInput?: string; // 邮编原始输入（支持逗号和换行，与 trackingNumbers 一致）
    addrModified?: boolean;
    hasManded?: boolean;
    cooperationWarehouseId?: number;
    prePickupHubName?: string;
    receivedAtHub?: [string | null, string | null] | null;
    deliverAt?: [string | null, string | null] | null;
    destHubArrivedAt?: [string | null, string | null] | null;
    destWarehouseArrivedAt?: [string | null, string | null] | null;
    overallStatus?: string[];
    overallStatuses?: string[];
    isComplaint?: boolean;
    podReviewStatus?: string;
    isAbnormal?: boolean;
    isHasBeenSetException?: boolean;
    exceptionReasonCode?: string;
    markExceptionAt?: [string | null, string | null] | null;
    nextAction?: string;
    nextActions?: string[];
    bagTaskNumbers?: string;
    pickupHubId?: string[];
    pickupHubIds?: number[];
    deliveredAt?: [string | null, string | null] | null;
    lastDeliveryScanTime?: [string | null, string | null] | null;
    updatedAt?: [string | null, string | null] | null;
    returnArrivalHubAt?: [string | null, string | null] | null;
    deliveredDspId?: number;
    deliveredDspIds?: number[];
    pickupTaskDate?: [string | null, string | null] | null;
    exceptionStatuses?: number[];
    sortingChannelOrderNumber?: string;
}

export const WMSParcelInitialValue: WMSOrderFiltersType = {
    currentWarehouseId: "0",
    sortingCode: "",
    trackingNumbers: undefined,
    platformId: undefined,
    channelId: undefined,
    channelOrderNumber: undefined,
    externalTrackingNumber: undefined,
    sortingCodeSegment1: undefined,
    sortingCodeSegment2: undefined,
    sortingCodeSegment3: undefined,
    hubId: undefined,
    warehouseId: undefined,
    receiverZipcode: undefined,
    receiverZipcodeInput: undefined,
    addrModified: undefined,
    hasManded: undefined,
    cooperationWarehouseId: undefined,
    prePickupHubName: undefined,
    // orderTime 默认值不写入这里（避免默认值被同步进 URL hash，导致刷新同一链接“时间不滚动”）
    // 由页面/查询层在运行时按“最近一周”计算默认值
    receivedAtHub: null,
    deliverAt: null,
    destHubArrivedAt: null,
    destWarehouseArrivedAt: null,
    overallStatus: undefined,
    isComplaint: undefined,
    podReviewStatus: undefined,
    isAbnormal: undefined,
    exceptionReasonCode: undefined,
    markExceptionAt: null,
    nextAction: undefined,
    nextActions: undefined,
    isHasBeenSetException: undefined,
    bagTaskNumbers: undefined,
    pickupHubId: undefined,
    deliveredAt: null,
    lastDeliveryScanTime: null,
    updatedAt: null,
    returnArrivalHubAt: null,
    deliveredDspId: undefined,
    deliveredDspIds: undefined,
    pickupTaskDate: null,
    sortingChannelOrderNumber: undefined
};